import { render, staticRenderFns } from "./MonitorMilestonesPaging.vue?vue&type=template&id=9d3615c6&"
import script from "./MonitorMilestonesPaging.vue?vue&type=script&lang=js&"
export * from "./MonitorMilestonesPaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports